import { Col } from 'antd';
import React, { useEffect, useState } from 'react';
import Accordion from '../components/Accordion/Accordion';
import { cleanString, createMarkup } from '../util/renderHelpers';

export type splittedContentsType = string[];
export type accordionContentType = Array<{ collapse?: string; content?: string; title?: string }>;
export type accordionsType = accordionContentType[];
export const useAccordions = (
  contentState: string,
  accordionChecker: string = '__antd_accordion_react__',
  accordionSplitter: string = '__antd_accordion_react_splitter__',
  accordionSelector: string = '.accordions',
  accordionDataAttr: string = '[data-accordion]'
) => {
  const [accordionsState, setAccordionsState] = useState<accordionsType>([]);
  const [splittedContents, setSplittedCotents] = useState<splittedContentsType>([]);
  useEffect(() => {
    // Convert string to dom element
    const content = document.createElement('div');
    content.innerHTML = cleanString(contentState);

    // Find acordions container (CCT)
    const acordionsContainers: HTMLElement[] = Array.from(
      content.querySelectorAll(accordionSelector)
    );

    // If we don't have accordions class inside matrix content page return and set empty arrays
    if (acordionsContainers.length === 0) {
      setAccordionsState([]);
      setSplittedCotents([]);
      return;
    }

    // Iterate for each accordions and build state for react antd component
    const accrodionState = acordionsContainers.map((acordionsContainer: HTMLElement) => {
      const accordions: HTMLElement[] = Array.from(
        acordionsContainer.querySelectorAll(accordionDataAttr)
      );
      const accordionsData = accordions.reduce(
        (acu, cur) => {
          return acu.concat({
            collapse: cur.dataset.accordion,
            content: cur.dataset.accordionContent,
            title: cur.dataset.accordionTitle,
          });
        },
        [] as accordionContentType
      );

      // Add splitter and checker keyword
      acordionsContainer.insertAdjacentHTML(
        'beforebegin',
        `${accordionSplitter} ${accordionChecker} ${accordionSplitter}`
      );

      // Remove accordion node from matrix content
      if (acordionsContainer.parentNode) {
        acordionsContainer.parentNode.removeChild(acordionsContainer);
      }

      return accordionsData;
    });

    setAccordionsState(accrodionState);
    setSplittedCotents(content.innerHTML.split(accordionSplitter));
  }, [contentState, accordionSelector, accordionDataAttr, accordionSplitter, accordionChecker]);
  // Count number of Accordion CCT
  let accordionNumber = 0;

  const displayContent =
    splittedContents.length > 0 ? (
      splittedContents.map((splitContent: string, index: number) =>
        splitContent.indexOf(accordionChecker) !== -1 ? (
          <Accordion
            key={`accordion-${index}`}
            accordionState={accordionsState[accordionNumber++]}
          />
        ) : (
          <Col lg={{ span: 24 }} key={index} dangerouslySetInnerHTML={createMarkup(splitContent)} />
        )
      )
    ) : (
      <Col lg={{ span: 24 }} dangerouslySetInnerHTML={createMarkup(cleanString(contentState))} />
    );
  return displayContent;
};
